import { useEffect, useState } from 'react'
import { $createLinkNode, $isLinkNode, $toggleLink, formatUrl, type LinkNode } from '@lexical/link'
import { Input, Modal } from 'antd'
import { $createTextNode, $getSelection, $isRangeSelection, type LexicalEditor } from 'lexical'
import { runInSelection } from '@/features/contract/utils/toolbar.ts'

export function LinkDialog({ editor, onClose, open }: { editor: LexicalEditor; onClose: () => void; open: boolean }) {
  const [url, setUrl] = useState('')
  const [text, setText] = useState('')

  useEffect(() => {
    if (!open) {
      return
    }
    editor.getEditorState().read(() => {
      const selection = $getSelection()
      if (!$isRangeSelection(selection)) {
        return
      }
      const node = selection.anchor.getNode()
      let parent = node.getParent()
      let link: LinkNode | null = null
      while (parent) {
        if ($isLinkNode(parent)) {
          link = parent
          break
        }
        parent = parent.getParent()
      }
      setText(selection.getTextContent())
      setUrl(link?.getURL() ?? '')
    })
  }, [editor, open])

  const apply = () => {
    const nextUrl = url.trim()
    if (!nextUrl) {
      runInSelection(editor, (selection) => {
        if ($isRangeSelection(selection)) {
          $toggleLink(null)
        }
      })
      onClose()
      return
    }
    const formattedUrl = formatUrl(nextUrl)
    runInSelection(editor, (selection) => {
      if (!$isRangeSelection(selection)) {
        return
      }
      if (selection.isCollapsed()) {
        const linkNode = $createLinkNode(formattedUrl, { rel: 'noopener noreferrer', target: '_blank' })
        linkNode.append($createTextNode(text.trim() || formattedUrl))
        selection.insertNodes([linkNode])
      } else {
        $toggleLink({ rel: 'noopener noreferrer', target: '_blank', url: formattedUrl })
      }
    })
    onClose()
  }

  return (
    <Modal cancelText="取消" okText="应用链接" onCancel={onClose} onOk={apply} open={open} title="插入链接">
      <div className="flex flex-col gap-3 py-2">
        <Input
          autoFocus
          onChange={(event) => setUrl(event.target.value)}
          placeholder="https://example.com"
          value={url}
        />
        <Input onChange={(event) => setText(event.target.value)} placeholder="链接文字（选填）" value={text} />
      </div>
    </Modal>
  )
}
